import React from 'react';
import {
  Text,
  TextProps,
} from '@fluentui/react-components';

import { ReactTemplate } from '@bingads-webui-react/react-template';

const getTemplate = (text: string, highlight: string) => {
  if (highlight === '') {
    return text;
  }

  const pattern = new RegExp(highlight, 'gi');

  return text.replace(pattern, '{{b}}$&{{/b}}');
};

export const TextWithHighlight: React.FC<TextProps & { text, hightlight }> = ({ text, hightlight, ...rest }) => {
  const template = getTemplate(text, hightlight);

  return (
    <Text {...rest}>
      <ReactTemplate
        template={template}
        model={{
          // eslint-disable-next-line react/no-unstable-nested-components
          b: (hightlightText) => <b>{hightlightText}</b>,
        }}
      />
    </Text>
  );
};
